import classNames from 'classnames'
import LoadingIcon from './icons/circleDots'
import SavedIcon from './icons/circleCheck'
import './loadingIndicator.css'

interface LoadingIndicatorProps {
  active: boolean
  loading: boolean
  size?: 'small' | 'medium'
}

export const LoadingIndicator = ({
  active,
  loading,
  size = 'medium',
}: LoadingIndicatorProps) => {
  return (
    <div
      className={classNames('loading-indicator', {
        'loading-indicator-active': active,
        'loading-indicator-small': size === 'small',
      })}
    >
      {loading ?
        <LoadingIcon />
      : <SavedIcon />}
    </div>
  )
}
